import React from 'react';

import classes from './ProgressBar.module.scss';

const ProgressBar = ({ className, value, max }) => {
  const percent = Math.round((100 * (!!value ? value : 0)) / (!!max ? max : 100));

  const percentStyle = `${percent}%`;

  const designBar = [classes.bar];
  if (className) {
    designBar.push(className);
  }

  return (
    <div
      className={designBar.join(' ')}
      style={{ background: `linear-gradient(to right, #2F97C1 ${percentStyle}, #E5E6ED 0%)` }}
    ></div>
  );
};

export default ProgressBar;
